import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type AppProviderMicroFrontendProps = SpecificMicroFrontendProps;

export const AppProviderMicroFrontend: FC<AppProviderMicroFrontendProps> = ({
  entryPointUrl,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_APP_PROVIDER_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      {...props}
    />
  );
};
